// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".permissionBox[data-v-6415600b] {\n  padding: 20px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.permissionClass[data-v-6415600b] {\n  max-height: 650px;\n  overflow: auto;\n}\n.permissionBox[data-v-6415600b]  .el-tabs__content {\n  padding: 0;\n}", ""]);
// Exports
module.exports = exports;
